import { render, staticRenderFns } from "./PageSerp.vue?vue&type=template&id=a82961e8&"
import script from "./PageSerp.vue?vue&type=script&lang=js&"
export * from "./PageSerp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports